// @flow
import { useEffect } from 'react';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { loadRecaptchaV3 } from '@tectonics/captcha/recaptcha-v3/load-recaptcha-v3';

export function useRecaptchaV3Initialization(incomingPayment: ?IncomingPayment) {
  useEffect(() => {
    if(!incomingPayment) {
      return;
    }
    if (incomingPayment.enable_recaptcha_v3_enterprise) {
      loadRecaptchaV3().catch((error) => {
        throw error;
      });
    }
  }, [incomingPayment]);
}
